<template>
  <modal transition="pop-out" :adaptive="true" name="image-upload" :width="550" :height="'auto'" @before-open="setValues">
    <div class="w-full">
      <div class="h-10 w-full border-b border-gray-200">
        <p class="px-8 py-2 text-gray-700 font-bold">Upload Image</p>
      </div>
      <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
        <div class="mb-4 mb-6" v-if="type === 'major' || type === 'minor'">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Link
          </label>
          <el-input placeholder="e.g www.algomart.com/category" v-model="link"></el-input>
        </div>
        <div class="mb-4 mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            File
          </label>
          <input @change="setFile" type="file" accept="image/png, image/jpeg, image/jpg">
        </div>
        <div class="flex items-center justify-between">
          <el-button @click="submit" type="primary" :loading="loading">Save</el-button>
        </div>
      </form>
    </div>
  </modal>

</template>

<script>
export default {
  name: 'UploadModal',
  data() {
    return {
      loading: false,
      type: null,
      link: null,
      file: null,
    };
  },
  computed: {
    height() {
      return this.type === 'major' || this.type === 'minor' ? 320 : 200;
    },
  },
  methods: {
    async submit() {
      try {
        this.loading = true;
        const data = new FormData();
        data.append('file', this.file);
        if (this.type === 'major' || this.type === 'minor') {
          if (!this.link || !this.file) {
            this.$notify.error({
              title: 'Error',
              message: 'Please make sure an image is selected and a link is provided.',
            });
            this.loading = false;
            return;
          }
          data.append('link', this.link);
        }

        await this.$store.dispatch('SettingsModule/Config/uploadMerchantImages', { type: this.type, data });
        await this.$store.dispatch('SettingsModule/Config/fetchMerchantProfile');
        this.$modal.hide('image-upload');
        this.loading = false;

        this.$notify.success({
          title: 'Success',
          message: 'Image successfully added',
        });
      } catch (e) {
        this.loading = false;
        this.$modal.hide('image-upload');

        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
    },
    setValues(event) {
      this.type = event.params.type;
    },
    setFile(event) {
      this.file = event.target.files[0];
    },
  },
};
</script>

<style scoped>

</style>
